// 获取数组对象中某一属性值的集合
export function getAttrs<T>(array: T[], attr: keyof T) {
    const arr = array.map((item: T) => {
        return item[attr];
    });
    return arr;
}
